import { IGetAllFeedsResponseData } from "api/services/feed/types";
import { IFormFeedData } from "./types";

export const feedFormsDataAdapter = (response: IGetAllFeedsResponseData[]): IFormFeedData[] => {
    return response.map(item => {
        return {
            id: item.id,
            sellerId: item.sellerId,
            title: item.title,
            marketId: item.marketId,
            isActive: item.isActive,
            isDeleted: item.isDeleted,
            filterId: item.filterId,
            frequency: item.frequency,
            generatedAt: item.generatedAt,
            generatedPIDs: item.generatedPIDs,
            warehouse: item.warehouse,
            stocksSourceWhID: item.stocksSourceWhID,
            isUpdatePrices: item.pricesInclude,
            isUpdateStocks: item.stocksInclude,
            isUpdateAttributes: item.productAttributesInclude,
            url: item.url
        }
    })
}